class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);



class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    
    (async () => {
        await this.fetchData();
        

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.addGiftProduct = this.addGiftProduct.bind(this);
        this.removeGiftProduct = this.removeGiftProduct.bind(this);
        this.handleMinOrderFee = this.handleMinOrderFee.bind(this);

         this.updateCartItem()
         
      
    })();
   
    
  }

  cartUpdateUnsubscriber = undefined;

  myTempData = 0;

  connectedCallback() { //console.log("==connectedCallback=="); 
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      console.log("== here it is =="); 
      this.myTempData = 0
      this.onCartUpdate();
    });
  }

  disconnectedCallback() { //console.log("==disconnectedCallback=="); 
    if (this.cartUpdateUnsubscriber) { 
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) { //console.log("==resetQuantityInput=="); 
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) { //console.log("==setValidity=="); 
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {  //console.log("==validateQuantity=="); 
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = '';

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min);
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace('[max]', event.target.max);
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace('[step]', event.target.step);
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      );
    }
  }

  onChange(event) { //console.log("==onChange=="); 
    this.validateQuantity(event);
  }
   
  onCartUpdate() { 

    (async () => {
        document.getElementById("mm_overlay").style.display = 'flex';
        await this.fetchData();
     
    
    
    
      //console.log("==onCartUpdate 0==");
      console.log(this.myTempData);
      //console.log("==onCartUpdate 0==");

      // ||  this.myTempData == 1 
      if( this.myTempData == 0   ){
        try {
            let response = await fetch(`${routes.cart_url}.json`) // Example API
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
             
            const newState = await this.checkminorderProduct(response).catch((error) => {
              console.log(error);
            });

            await this.updateCartview()
            await this.updateCartItem()
            document.getElementById("mm_overlay").style.display = 'none';
            } catch (error) {
            console.error("Error fetching data:", error);
        }

         
       
      }else{
                
            await this.updateCartview()
            await this.updateCartItem()
            document.getElementById("mm_overlay").style.display = 'none';
      }
     

    })();
  }
  async updateCartview(){
      try {
          /*let response = await fetch("/cart.js"); // Example API
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
          let cart = await response.json();
          
          

          if( cart.item_count >= 1){

            let isThisItem = 0 ; 
 
            cart.items.forEach((section => {
               
              if(section.id==43823302508724){ isThisItem = 43823302508724; }
              if(section.id==43823302475956){ isThisItem = 43823302475956; }

            }))
            
            if(isThisItem != 0){
                  let minFeeId  = isThisItem;

                  const body = JSON.stringify({
                      id: minFeeId ,
                      quantity: 1,
                    });

                  console.log("ADD = REMOVE Start")
                  let response = await    fetch('/cart/change.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify({ quantity: 0, id: minFeeId.toString() }),
                    })
                    .then((response) => response.json())
                    .then((response) => { 
                        console.log("REMOVE done")

                        let state =  fetch(`${routes.cart_add_url}`, {
                          ...fetchConfig(),
                          body,
                        }).then((response) => response.json())
                        .then((response) => { 
                             console.log("ADDED done")
                               this.updateCartViewAfter()
                        });

                    }); 


                  console.log("ADD = REMOVE done")

            }

            await this.updateCartViewAfter()

          } else{
            
          }*/
           
          this.updateCartViewAfter()
 
          // Next code runs only after fetch is completed
          //console.log("Fetch completed. Proceeding updateCartItem");
      } catch (error) {
          console.error("Error fetching data:", error);
      }
      
  }
  async updateCartViewAfter(){
        console.log("updateCartViewAfter");
        console.log(this);
        console.log('tagName', this.tagName)
      if (this.tagName === 'CART-DRAWER-ITEMS') {
        fetch(`${routes.cart_url}?section_id=cart-drawer`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const selectors = ['cart-drawer-items', '.cart-drawer__footer','.free-shipping-progress'];
            for (const selector of selectors) {
              const targetElement = document.querySelector(selector);
              const sourceElement = html.querySelector(selector);
              if (targetElement && sourceElement) {
                targetElement.replaceWith(sourceElement);
              }
            }
          })
          .catch((e) => {
            console.error(e);
          });
      } else 
      {
        fetch(`${routes.cart_url}?section_id=main-cart-items`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('cart-items');
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      } 
  }
  async updateCartItem(){
      try {
          let response = await fetch("/cart.js"); // Example API
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
          let cart = await response.json();
          
          //console.log("****"+cart.item_count+"****");

          if( cart.item_count >= 1){

            let isThisItem = 0 ; 

            let cartCount = cart.item_count ;

            cart.items.forEach((section => {
               
              if(section.id==43823302508724){
                cartCount = cartCount - 1 ; 
                isThisItem =   1;
              }
              if(section.id==43823302475956){   
                cartCount = cartCount - 1 ; 
                isThisItem =   1;
              }

            }))

            
             
            var chkbtn = document.querySelector(".qiuckorder_checkout .cart__checkout-button");
            if(chkbtn){              chkbtn.disabled = false;            }


            var cartitemcouttxt1 = document.querySelector("a#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']");
            if( cartitemcouttxt1){ cartitemcouttxt1.innerText = cartCount }
            var cartitemcouttxt2 = document.querySelector(".cart-count-bubbles span");
            if( cartitemcouttxt2){ cartitemcouttxt2.innerText = cartCount }


            var var1 = document.querySelector("#CartDrawer .drawer__inner-empty")
            if(var1){ var1.style.display = "none"; }

            /*var var2 = document.querySelector("#order-minimum-modal")
            if(var2){ var2.style.display = "block"; }*/
            var var3 = document.querySelector("#CartDrawer .free-shipping-progress");
            if(var3){ var3.style.display = "block" }
            var var4 = document.querySelector("cart-drawer")
            if(var4){ var4.classList.remove("is-empty"); }

            if(isThisItem == 1 &&  cart.item_count == 1  && window.location.pathname === "/cart" ){

              setTimeout(() => {
                window.location.reload();
              }, 2000);
              return false;
              /*console.log("YES THATS IT")
                 var var5 = document.querySelector("cart-items")
                if(var5){ var5.classList.remove("is-empty"); }
                var var6 = document.querySelector("cart-items .free-shipping-progress");
                if(var6){ var6.style.display = "none" }
                  var var7 = document.querySelector("cart-items #order-minimum-modal_cart");
                if(var7){ var7.style.display = "none" }
                   var var8 = document.querySelector(".cart__footer-wrapper");
                if(var8){ var8.style.display = "none" }*/
                  
            }

          }else {
            var chkbtn = document.querySelector(".qiuckorder_checkout .cart__checkout-button");
            if(chkbtn){ chkbtn.disabled = true;            }

 
            var var2 = document.querySelector("#order-minimum-modal")
            if(var2){ var2.style.display = "none"; }
             var var3 = document.querySelector("#CartDrawer .free-shipping-progress");
            if(var3){ var3.style.display = "none" }
            var var4 = document.querySelector("cart-drawer")
            if(var4){ var4.classList.add("is-empty"); }

            var var1 = document.querySelector("#CartDrawer .drawer__inner-empty")
            if(var1){ var1.style.display = "none"; }

             
            const str = '<div class="drawer__inner-empty">          <div class="cart-drawer__warnings center">            <div class="cart-drawer__empty-content">              <h2 class="cart__empty-text">Your cart is empty</h2>              <button class="drawer__close" type="button" onclick="this.closest('+"'cart-drawer'"+').close()" aria-label="Close">                <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17"><path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path></svg></span>              </button>              <a href="/collections/all" class="button">                Continue shopping              </a></div>          </div></div>';
            document.querySelector("#CartDrawer .drawer__inner").insertAdjacentHTML( 'afterbegin', str );

          }
  
          // Next code runs only after fetch is completed
          //console.log("Fetch completed. Proceeding updateCartItem");
      } catch (error) {
          console.error("Error fetching data:", error);
      }
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }
  

  async updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then(async (state) => {
        const parsedState = JSON.parse(state);
        //console.log("==3==")
        this.myTempData = 0
        const newState = await this.checkminorderProduct(parsedState).catch((error) => {
          console.log("=4==")
          console.log(error);
        })

        const quantityElement =
          document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll('.cart-item');
        
        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }
        //if (newState && (newState.action === "ADDED" || newState.action === "REMOVED")) {
        //  this.refreshCart(line, quantity, name, variantId);   
        //} else {
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartDrawerWrapper = document.querySelector('cart-drawer');
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
          if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          });
          const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
          let message = '';
          if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
            if (typeof updatedValue === 'undefined') {
              message = window.cartStrings.error;
            } else {
              message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
            }
          }
          this.updateLiveRegions(line, message);

          const lineItem =
            document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
            cartDrawerWrapper
              ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
              : lineItem.querySelector(`[name="${name}"]`).focus();
          } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
          } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
            trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
          }

          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        //}
      })
    
      .catch(() => {
        this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
      });
   
  }

  refreshCart(line, quantity, name, variantId) {

    console.log("--refreshCart--");

    fetch(`${routes.cart_url}`, {...fetchConfig()}).then((res) => res.text()).then((state) => {
     let parsedState = JSON.parse(state);

      fetch(window.Shopify.routes.root + "?sections="+this.getSectionsToRender().map((section) => section.section).join(","))
         .then(res => res.json()).then((res) => {
           this.classList.toggle('is-empty', parsedState.item_count === 0);
           const cartDrawerWrapper = document.querySelector('cart-drawer');
           const cartFooter = document.getElementById('main-cart-footer');
   
           if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
           if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
   
           this.getSectionsToRender().forEach((section => {
             const elementToReplace =
               document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
             elementToReplace.innerHTML =
               this.getSectionInnerHTML(res[section.section], section.selector);
           }));
   
           this.updateLiveRegions(line, parsedState.item_count);
           const lineItem =  document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
           if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
             cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
           } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
             trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
           } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
             trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
           }
           this.disableLoading();
         }).catch((error) => {
           console.log(error);
         });
      this.disableLoading();
   }).catch((error) => {
     console.log(error);
     this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
     const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
     errors.textContent = window.cartStrings.error;
     this.disableLoading();
   })
 }


  

async handleMinOrderFee(parsedState, totalToCheck, minFeeId, limitAmount, feeAmount) {

  
  let availableIndex = -1;
  //console.log(parsedState.items)

   

   try {
      let response = await fetch('/cart.js')
      if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
      }
      let cart = await response.json();
      var thisItemAvailble = 0
      cart.items.forEach((item => { 
          if(item.id == minFeeId){
              thisItemAvailble = 1; 
          }
          console.log("1",item)
          if(item.product_id==7926620717236){
            //this.myTempData = this.myTempData + 1 
              //this.removeGiftProduct(item.id.toString());
            //this.onCartUpdate();
            //location.reload()
            
          }

      }))

      
        var cartTotal = cart.total_price  
        limitAmount = limitAmount * 100 ; //console.log(limitAmount)
        console.log(limitAmount)
        console.log(cartTotal)

      if(thisItemAvailble==1){
        //console.log("Yes");
        var cartTotal = cart.total_price - ( feeAmount * 100 )
        if (cartTotal < limitAmount) { 
          console.log("Already availble");
          //await this.removeGiftProduct(minFeeId.toString());
          //await  this.addGiftProduct(minFeeId);
          //const state =   this.addGiftProduct(minFeeId);
        }else{
          await this.removeGiftProduct(minFeeId.toString());
          //this.onCartUpdate();
          console.log("Minimum order requirement not met. > ");
        }
      }else{
        //console.log("NO");
        if (cartTotal < limitAmount) { 
          console.log("Minimum order requirement not met. < ");

          //await this.removeGiftProduct(minFeeId.toString());
          await  this.addGiftProduct(minFeeId);
          //this.refreshCartState();
          //this.onCartUpdate();
        }else{
          console.log("No need to add ");
        }
      }

      

      closeModelCall()
      setTimeout(() => {
         
        this.myTempData = this.myTempData + 1 ;
        this.onCartUpdate();
        //window.location.reload();
         console.log("Delayed for 1 second.");
      }, 1000);
      // page refresh 
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  
 
  return { action: "NO ACTION" };
}

  async   fetchData() {
    //alert("d")
      try {
          let response = await fetch("/cart.js"); // Example API
          if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
          }
          let cart = await response.json();
            cart.items.forEach((section => {
              if( cart.item_count == 1){
                 
                if(section.id==43823302508724){
                  //this.myTempData = this.myTempData + 1 
                    this.removeGiftProduct(section.id.toString());
                  //this.onCartUpdate();
                }
                if(section.id==43823302475956){
                  //this.myTempData = this.myTempData + 1 
                    this.removeGiftProduct(section.id.toString());
                  //this.onCartUpdate();
                }
              };
              //console.log("5",section)
              if(section.product_id==7926620717236){
                //this.myTempData = this.myTempData + 1 
                  //this.removeGiftProduct(section.id.toString());
                //this.onCartUpdate();
                //location.reload()
                
              }
            }))
  
          // Next code runs only after fetch is completed
          //console.log("Fetch completed. Proceeding to next operation...");
      } catch (error) {
          console.error("Error fetching data:", error);
      }
  }
  

//  MIn order script
  async addGiftProduct(minFeeId) {
    const body = JSON.stringify({
      id: minFeeId,
      quantity: 1,
    });

    const state = await fetch(`${routes.cart_add_url}`, {
      ...fetchConfig(),
      body,
    }).then((res) => res.json()).catch((error) => {
      console.log(error);
    });

    return state;
  }
async removeGiftProduct(minFeeId) {
   
  try {
          let response = await    fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({ quantity: 0, id: minFeeId }),
            })
            .then((response) => response.json())
            .then((response) => { 
               return { action: "NO ACTION" };
            }); 
   } catch (error) {
          console.error("Error fetching data:", error);
      }
}


async refreshCartState() {
  const cart = await fetch('/cart.js')
    .then(response => response.json())
    .catch(error => {
    });

  if (cart) {
  }
}

async checkminorderProduct(parsedState) {
  var totalToCheck = parsedState.items_subtotal_price / 100;
  const company = document.getElementById("ctm_customer_company")?.value;
  const minOrderType = document.getElementById("ctm_customer_min_order_type")?.value;
  //console.log(minOrderType)
  
  if ( minOrderType === "MINORD") {
    const minFee50 = 43823302508724; 
    return await this.handleMinOrderFee(parsedState, totalToCheck, minFee50, 500, 50);
  } else if (  minOrderType === "MINORD2") {
    const minFee25 = 43823302475956; 
    return await this.handleMinOrderFee(parsedState, totalToCheck, minFee25, 250, 25);
  }

  return { action: "NO ACTION" };
}

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').textContent = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

function closeModelCall(){
  
  //document.addEventListener("readystatechange", function() {
    var modal = document.getElementById("order-minimum-modal");
    var closeModal = document.getElementById("close-modal");
    
    if (modal && closeModal) {
     
      // Hide modal when clicking close button
      closeModal.addEventListener("click", function() {
        
        modal.style.display = "none";
      });
    } else {
      console.error("Modal elements not found in the DOM.");
    }
  
  //});

}

document.addEventListener("DOMContentLoaded", function () {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        console.log('cart', cart)

        const feeItem = cart.items.find(item => item.product_id === 7926620717236 );
        console.log('feeItem', feeItem)
        if (feeItem) {
          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: feeItem.key,
              quantity: 0
            })
          }).then(() => location.reload());
        }
      });
  });
